/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import { useContext, type ReactNode } from 'react';
import type { SnippetsSectionProps } from '../Snippets/types';
import { Text } from './Text';
import { SnippetsSection } from '../Snippets/SnippetsSection';
import { SkeletonLoader } from '../SkeletonLoader/SkeletonLoader';
import { SECTION_NAME_EXPLORE } from '../../../constants/snippetsSectionNames';
import { InstallationSettingsContext } from '../../../contexts/InstallationSettingsContext';

export function Explore( { number, isLoading }: SnippetsSectionProps ): ReactNode {
	const { selectedCodeOutput } = useContext( InstallationSettingsContext );

	return (
		<SkeletonLoader number={ number } sectionTitle={ SECTION_NAME_EXPLORE } isLoading={ isLoading }>
			<SnippetsSection headerCharacter={ number } title={ SECTION_NAME_EXPLORE }>
				{ selectedCodeOutput === 'stackblitz' ? (
					<Text dataTestId={ 'explore-description' }>
						The code in StackBlitz is fully editable, so freely explore the editor and its setup. { ' ' }
						If you want to test premium feature and add license keys, { ' ' }
						<b>make sure to always switch StackBlitz to secret or private version</b>.
					</Text>
				) : (
					<Text dataTestId={ 'explore-description' }>
						Open the downloaded sample project and test locally your editor.
					</Text>
				) }
			</SnippetsSection>
		</SkeletonLoader>
	);
}
